import { Application } from '@/graphql/generated'
import { User } from '@/types/unlock'
import { isHSRUser, isHeoManager, isSalesUser } from '@/utils/user'

type ThirdPartyReportPermissions = {
  appraisal: boolean
  avm: boolean
  credit: boolean
  propertyDetails: boolean
  flood: boolean
  title: boolean
}

export const getHEOManagerThirdPartyReportPermissions = (
  application: Application
): ThirdPartyReportPermissions => {
  if (application.applicationStateIndex >= 4) {
    return {
      appraisal: false,
      avm: false,
      credit: true,
      propertyDetails: false,
      flood: false,
      title: false,
    }
  } else {
    return {
      appraisal: false,
      avm: true,
      credit: true,
      propertyDetails: true,
      flood: true,
      title: false,
    }
  }
}

export const getThirdPartyReportPermissions = (
  user: User,
  application: Application
): ThirdPartyReportPermissions => {
  if (user?.is_superuser) {
    return {
      appraisal: true,
      avm: true,
      credit: true,
      propertyDetails: true,
      flood: true,
      title: true,
    }
  }

  if (isHeoManager(user)) {
    return getHEOManagerThirdPartyReportPermissions(application)
  }

  if (isHSRUser(user)) {
    return {
      appraisal: false,
      avm: false,
      credit: true,
      propertyDetails: true,
      flood: true,
      title: false,
    }
  }

  if (isSalesUser(user)) {
    return {
      appraisal: true,
      avm: false,
      credit: true,
      propertyDetails: true,
      flood: true,
      title: true,
    }
  }

  return {
    appraisal: true,
    avm: true,
    credit: true,
    propertyDetails: true,
    flood: true,
    title: true,
  }
}
